<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" justify="center">
        <v-card class="mx-auto text-center" color="blue-grey" dark>
          所属グループ選択
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-data-table
          :headers="headers"
          :items="groups"
          :items-per-page.sync="perPage"
          :footer-props="{'items-per-page-options': [10, 20, 30, 50, 100, -1]}"
          dense
          disable-sort
          :loading="isGroupsLoding" loading-text="読込中"
          mobile-breakpoint="0"
          >
          <!-- グループ名とモバイル用まとめ -->
          <template #[`item.groupName`]="{ item }">
            <v-row dense class="hidden-sm-and-down">
              <v-col cols="12" justify="center">
                {{ item.groupName }}
              </v-col>
            </v-row>

            <!-- モバイル用まとめ -->
            <v-row dense class="hidden-md-and-up">
              <v-col cols="12" justify="center">
                <!-- １行目(グループ名＋お気に入りボタン) -->
                <v-row>
                  <v-col cols="6" class="text-subtitle-1">
                    {{ item.groupName }}
                  </v-col>
                  <v-col cols="6" class="d-flex justify-end text-caption">
                    <v-tooltip top v-if="item.favoriteFlg">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small outlined v-bind="attrs" v-on="on" @click="changeFavoriteGroup(item)"><v-icon color="orange">mdi-star</v-icon></v-btn>
                      </template>
                      <span>お気に入りを解除する</span>
                    </v-tooltip>
                    <v-tooltip top v-if="!item.favoriteFlg">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small outlined v-bind="attrs" v-on="on" @click="changeFavoriteGroup(item)"><v-icon>mdi-star-outline</v-icon></v-btn>
                      </template>
                      <span>お気に入りに追加する</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <!-- ２行目 -->
                <v-row>
                  <v-col cols="3" class="d-flex justify-start text-caption">
                    <v-btn small color="accent" class="black--text" :disabled="!item.canViewFlg" @click="onClicktoUserList(item)">生徒一覧</v-btn>
                  </v-col>
                  <v-col cols="3" class="d-flex justify-center text-caption">
                    <v-btn small color="accent" class="black--text" @click="onClicktoGroupMemberList(item)">所属者一覧</v-btn>
                  </v-col>
                  <v-col cols="3" class="d-flex justify-center text-caption">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon outlined small v-bind="attrs" v-on="on" :disabled="item.groupPattern != 'CLASS'" @click="showReportDialog(item)">
                          <v-icon color="green">mdi-file-excel</v-icon>
                        </v-btn>
                      </template>
                      <span>出欠状況をExcel出力する</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="3" class="d-flex justify-end text-caption">
                    <v-btn small color="accent" class="black--text" :disabled="!item.canViewFlg" @click="onClicktoCourseSelectView(item)">コース選択</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>

          <!-- お気に入りボタン -->
          <template #[`item.favoriteFlg`]="{ item }">
            <v-tooltip top v-if="item.favoriteFlg">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small outlined v-bind="attrs" v-on="on" @click="changeFavoriteGroup(item)"><v-icon color="orange">mdi-star</v-icon></v-btn>
              </template>
              <span>お気に入りを解除する</span>
            </v-tooltip>
            <v-tooltip top v-if="!item.favoriteFlg">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small outlined v-bind="attrs" v-on="on" @click="changeFavoriteGroup(item)"><v-icon>mdi-star-outline</v-icon></v-btn>
              </template>
              <span>お気に入りに追加する</span>
            </v-tooltip>
          </template>

          <template #[`item.action`]="{ item }">
            <v-row dense>
              <v-col md="3" lg="3" xl="3">
                <v-btn small color="accent" class="black--text" :disabled="!item.canViewFlg" @click="onClicktoUserList(item)">生徒一覧</v-btn>
              </v-col>
              <v-col md="3" lg="3" xl="3">
                <v-btn small color="accent" class="black--text" @click="onClicktoGroupMemberList(item)">所属者一覧</v-btn>
              </v-col>
              <v-col md="3" lg="3" xl="3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined small v-bind="attrs" v-on="on" :disabled="item.groupPattern != 'CLASS'" @click="showReportDialog(item)">
                      <v-icon color="green">mdi-file-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>出欠状況をExcel出力する</span>
                </v-tooltip>
              </v-col>
              <v-col md="3" lg="3" xl="3">
                <v-btn small color="accent" class="black--text" :disabled="!item.canViewFlg" @click="onClicktoCourseSelectView(item)">コース選択状況</v-btn>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- 帳票出力ダイアログ -->
    <v-dialog
      v-model="viewReportDialog"
      max-width="700"
      min-height="120"
      persistent
    >
      <v-card
        class="d-flex flex-column mx-auto my-auto flat"
        color="#fff"
      >
        <v-card-actions class="mt-0 mb-2">
          <v-row dense>
            <v-col cols="2" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" color="grey" @click="viewReportDialog = false">
                    <v-icon color="white">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>閉じる</span>
              </v-tooltip>
            </v-col>
            <v-col cols="8" class="d-flex justify-center">
              指定学級の出欠情報をExcel出力する
            </v-col>
            <v-col cols="2" justify="center">
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text class="d-flex justify-center flex-column">
          <v-row>
            <v-col dense cols="12" class="d-flex justify-end">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small color="green" v-bind="attrs" v-on="on" class="black--text" :disabled="isExportingFlg1" :loading="isExportingFlg1" @click="exportAttendanceSummaryMonthly()">月別出欠集計<v-icon right dark>mdi-file-excel</v-icon></v-btn>
                </template>
                <div>指定学級の当年度における出欠を月別に集計し</div>
                <div>Excelファイルとして出力します</div>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row>
            <v-col dense cols="12" class="d-flex justify-end">
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col dense cols="6" class="d-flex justify-start">
              <v-select
                label="指定月"
                :items="monthList"
                item-text="monthStr"
                item-value="monthCd"
                v-model="exportMonthCd"
                outlined
                dense
                :disabled="isExportingFlg2"
                hide-details="auto"
              ></v-select>
            </v-col>
            <v-col dense cols="6" class="d-flex justify-end">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small color="green" v-bind="attrs" v-on="on" class="black--text" :disabled="isExportingFlg2" :loading="isExportingFlg2" @click="exportSyutteiSummary()">個人別出停集計<v-icon right dark>mdi-file-excel</v-icon></v-btn>
                </template>
                <div>指定学級の指定月における生徒毎の出停数を集計し</div>
                <div>Excelファイルとして出力します</div>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { httpsCallable, getFunctions } from "firebase/functions";
import { format, parse } from 'date-fns';
import { ja } from 'date-fns/locale';
import { saveAsCommon } from '../../common';
export default {
  data() {
    return {
      headers: [
        { text: "グループ名", value: "groupName", class: "hidden-sm-and-down", width: "200" },
        { text: "お気に入り", value: "favoriteFlg", class: "hidden-sm-and-down", cellClass: "hidden-sm-and-down", width: "50" },
        { text: "" , value:"action", class: "hidden-sm-and-down", cellClass: "hidden-sm-and-down" },
      ],
      groups: [],
      isGroupsLoding: false,
      perPage: 30,
      
      // 帳票出力用
      viewReportDialog: false,
      exportGroupId: "",
      exportMonthCd: "",
      monthList: [],
      // 月別出欠集計の出力ボタン制御用
      isExportingFlg1: false,
      isExportingFlg2: false,
    };
  },
  watch: {
    perPage: function(newVal) {
      this.$store.dispatch('setParPageGroupSelect', newVal);
    },
  },
  // 初期表示時データ読み込み
  async created() {
    this.perPage = this.$store.state.parPageGroupSelect;

    // 帳票出力ダイアログ用の指定月リスト生成
    const functions = getFunctions(this.$firebase);
    functions.region = "asia-northeast1";
    const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
    await schoolAidHomeLogined({funcName: "commonGetNendo"}).then((ret) => {
      var tounendo = ret.data.tounendo;
      var fromDateStr = (tounendo) + "-04-01";
      var fromDate = parse(fromDateStr, 'yyyy-MM-dd', new Date());
      this.exportMonthCd = fromDateStr;
      var monthList = [];
      // 当年度用の月指定リストの生成
      for(var i = 0; i < 12; i++){
        let monthCd = format(fromDate, 'yyyy-MM-dd', { locale: ja });
        let monthStr = format(fromDate, 'yyyy年MM月', { locale: ja });
        monthList.push({monthCd:monthCd, monthStr:monthStr});
        fromDate.setMonth(fromDate.getMonth() + 1);
      }
      this.monthList = monthList;
    });

    await this.reload();
  },
  methods: {
    // ページ再読込
    async reload() {
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      this.isGroupsLoding = true;
      schoolAidHomeLogined({funcName:"loadGroupSelect"}).then((groups) => {
        var ret = [];
        groups.data.forEach((group) => {
          var row = {
            groupId : group.groupId,
            favoriteFlg: group.favoriteFlg,
            groupName: group.groupName,
            groupPattern: group.groupPattern,
            canViewFlg: group.canViewFlg,
          };
          ret.push(row);
        });
        this.groups = ret;
        this.isGroupsLoding = false;
      });
    },
    async changeFavoriteGroup(item)  {      
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
      var data = {
        funcName: "changeFavoriteGroup",
        groupId: item.groupId,
        favoriteFlg: item.favoriteFlg
      };
      await schoolAidHomeLogined(data);
      this.reload();
    },
    // 所属者一覧
    onClicktoGroupMemberList(item) {
      this.$router.push({
        name: "GroupMemberList",
        params: {
          groupName:item.groupName,
          groupId:item.groupId,
          beforeName:"GroupSelect"
        }
      });
    },
    // 生徒一覧グループ選択
    onClicktoUserList(item) {
      console.log(item.groupName, item.groupId);
      var yyyymmdd = format(new Date(), 'yyyy-MM-dd', { locale: ja });
      this.$router.push({
        name: "UserList",
        params: {
          groupName:item.groupName,
          groupId:item.groupId,
          param_yyyymmdd: yyyymmdd,
        }
      });
    },
    // コース選択状況
    onClicktoCourseSelectView(item) {
      this.$router.push({
        name: "CourseSelectView",
        params: {
          groupName:item.groupName,
          groupId:item.groupId,
        }
      });
    },
    // 月別出欠集計Excelファイルの出力
    async exportAttendanceSummaryMonthly()  {
      var result = confirm("当年度の月別出欠集計Excelファイルを出力してよろしいですか？");
      if (!result) {
        return;
      }
      // ローディング開始
      this.isExportingFlg1 = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      
      var param = {
        funcName: "exportAttendanceSummaryMonthly",
        groupId: this.exportGroupId,
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then((ret) => {
        if(ret.data.message){
          alert(ret.data.message);
        } else {
          saveAsCommon(ret.data.downloadUrl, ret.data.fileName);
          alert("ダウンロードを開始します。\nダウンロードフォルダをご確認ください。\n※ファイルを確認出来ない場合はポップアップがブロックされていないか\nご確認ください。");
        }
      });
      // ローディング終了
      this.isExportingFlg1 = false;
    },
    // 個人別出停集計Excelファイルの出力
    async exportSyutteiSummary()  {
      var result = confirm("個人別出停集計Excelファイルを出力してよろしいですか？");
      if (!result) {
        return;
      }
      // ローディング開始
      this.isExportingFlg2 = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      
      var param = {
        funcName: "exportSyutteiSummary",
        groupId: this.exportGroupId,
        monthCd: this.exportMonthCd,
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then((ret) => {
        if(ret.data.message){
          alert(ret.data.message);
        } else {
          saveAsCommon(ret.data.downloadUrl, ret.data.fileName);
          alert("ダウンロードを開始します。\nダウンロードフォルダをご確認ください。\n※ファイルを確認出来ない場合はポップアップがブロックされていないか\nご確認ください。");
        }
      });
      // ローディング終了
      this.isExportingFlg2 = false;
    },
    // 帳票出力ダイアログの表示
    showReportDialog(item) {
      this.exportGroupId = item.groupId;
      this.viewReportDialog = true;
    }
  },
};
</script>